import React from 'react';
import './ui';
import './Auth.css';

// Firebase's messages are technical and in English; people see these instead.
const MESSAGES = {
  'auth/invalid-credential': ['Email sau parolă greșită.', 'Wrong email or password.'],
  'auth/wrong-password': ['Email sau parolă greșită.', 'Wrong email or password.'],
  'auth/user-not-found': ['Email sau parolă greșită.', 'Wrong email or password.'],
  'auth/admin-restricted-operation': ['Conturile se creează doar pe bază de invitație. Vorbește cu managerul fermei.', 'Accounts are by invitation only. Talk to your farm manager.'],
  'auth/invalid-email': ['Adresa de email nu este corectă.', 'That email address is not valid.'],
  'auth/too-many-requests': ['Prea multe încercări. Așteaptă câteva minute și încearcă din nou.', 'Too many attempts. Wait a few minutes and try again.'],
  'auth/network-request-failed': ['Nu există conexiune la internet.', 'There is no internet connection.'],
  'auth/popup-blocked': ['Browserul a blocat fereastra Google. Permite ferestrele pentru acest site.', 'The browser blocked the Google window. Allow pop-ups for this site.'],
  'auth/user-disabled': ['Contul este dezactivat. Vorbește cu managerul fermei.', 'This account is deactivated. Talk to your farm manager.'],
  'auth/email-already-in-use': ['Există deja un cont cu acest email.', 'An account with this email already exists.'],
  'auth/weak-password': ['Parola este prea slabă. Alege una mai lungă.', 'That password is too weak. Choose a longer one.'],
};
const TEXT_MESSAGES = {
  'Account is deactivated': ['Contul este dezactivat. Vorbește cu managerul fermei.', 'This account is deactivated. Talk to your farm manager.'],
  'Farm is not active': ['Ferma nu este activă.', 'This farm is not active.'],
  'User data not found': ['Contul nu a fost găsit. Vorbește cu managerul fermei.', 'Account not found. Talk to your farm manager.'],
  'Account not found. Please contact your farm manager.': ['Acest cont nu are acces. Conturile se creează doar pe bază de invitație.', 'This account has no access. Accounts are by invitation only.'],
  'Invalid invitation code': ['Codul de invitație nu este valid.', 'That invitation code is not valid.'],
};

export const authErrorText = (error, ro) => {
  const known = MESSAGES[error?.code] || TEXT_MESSAGES[error?.message];
  if (known) return known[ro ? 0 : 1];
  return ro ? 'Nu a mers. Verifică datele și încearcă din nou.' : 'That did not work. Check the details and try again.';
};

export const AuthLayout = ({ title, text, children }) => (
  <div className="au">
    <header className="au-brand">
      <div className="au-logo"><img src="/logo-farmtrackpro.svg" alt="" width="42" height="42" />FarmTrack Pro</div>
      <h1>{title}</h1>
      {text && <p>{text}</p>}
    </header>
    <main className="au-main"><section className="au-card">{children}</section></main>
  </div>
);

export const PasswordInput = ({ show, onToggle, ro, ...props }) => (
  <span className="au-password">
    <input type={show ? 'text' : 'password'} {...props} />
    <button type="button" onClick={onToggle} aria-pressed={show}>{show ? (ro ? 'Ascunde' : 'Hide') : (ro ? 'Arată' : 'Show')}</button>
  </span>
);
